module.exports = __webpack_public_path__ + "img/霞洞上河古荔园.212c6d6e.png";